import { render, staticRenderFns } from "./HotelsAvailabilityWrapper.vue?vue&type=template&id=398afb84&scoped=true&"
import script from "./HotelsAvailabilityWrapper.vue?vue&type=script&lang=ts&"
export * from "./HotelsAvailabilityWrapper.vue?vue&type=script&lang=ts&"
import style0 from "./HotelsAvailabilityWrapper.vue?vue&type=style&index=0&id=398afb84&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "398afb84",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/code/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('398afb84')) {
      api.createRecord('398afb84', component.options)
    } else {
      api.reload('398afb84', component.options)
    }
    module.hot.accept("./HotelsAvailabilityWrapper.vue?vue&type=template&id=398afb84&scoped=true&", function () {
      api.rerender('398afb84', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "module/Availability/view/vue/components/HotelsAvailabilityWrapper.vue"
export default component.exports